const rootActionPath = 'core/Testimonials';

export const TESTIMONIALS_VIEW = `${rootActionPath}/VIEW`;
export const TESTIMONIALS_SWIPED_TRIGGER = `${rootActionPath}/TRIGGER`;
